import { ColumnsType } from 'antd/es/table'
import PantoneBrandTag from '../../../components/pantone-brand-tag/pantone-brand-tag'
import { formatPantoneLabel } from '../../../helpers/entities/pantone/format-pantone-label'
import Pantone from '../../../types/api/pantone'

/** Колонки справочника: пантон, бренд и пары «Цвет | Г» по числу колорантов в самом длинном рецепте. */
export const getPaintsColumns = (colorantsCount: number): ColumnsType<Pantone> => [
    {
        key: 'name',
        title: 'Пантон',
        width: 140,
        fixed: 'left',
        render: (_, record) => formatPantoneLabel(record.name, record.version),
    },
    {
        key: 'manufacturer',
        title: 'Бренд',
        width: 70,
        render: (_, record) => <PantoneBrandTag manufacturerName={record.manufacturer?.name} />,
    },
    ...Array.from({ length: colorantsCount }, (_, index) => ({
        key: `colorant-${index}`,
        title: `Колорант ${index + 1}`,
        children: [
            {
                key: `colorant-${index}-name`,
                title: 'Цвет',
                width: 140,
                render: (_: unknown, record: Pantone) => record.colorants?.[index]?.colorant?.name,
            },
            {
                key: `colorant-${index}-amount`,
                title: 'Г',
                width: 70,
                render: (_: unknown, record: Pantone) => record.colorants?.[index]?.amount,
            },
        ],
    })),
]
